import { useTheme } from '@mui/material'

import useIsMobile from '../../utils/hooks/useIsMobile'
import FullScreenDrawer from '../full-screen-drawer'
import BasicDialog, { IBasicDialogProps } from '../m3/basic-dialog'

import classes from './index.styles'

interface IProps extends IBasicDialogProps {
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  children: React.ReactNode
  isFullScreen?: boolean
}

/**
 * This component renders a full screen drawer modal on mobile and a dialog on desktop
 */
const FullScreenModal = ({ maxWidth, isFullScreen, children, ...props }: IProps) => {
  const theme = useTheme()
  const isMobile = useIsMobile()

  return isMobile ? (
    <FullScreenDrawer {...props} modalPaperStyle={classes.modalPaperStyle(theme)} isFullScreen={isFullScreen}>
      {children}
    </FullScreenDrawer>
  ) : (
    <BasicDialog {...props} hideCancelButton={true} textContent={children} maxWidth={maxWidth ?? 'xs'} fullWidth={!!maxWidth} />
  )
}

export default FullScreenModal
